module.exports = __webpack_public_path__ + "img/link-banner-fr.62c0bebf.png";